export enum GTMEventType {
  HOME_PAGE_VIEWED = 'Home Page Viewed',
  TOP_UP_BALANCE_PAGE_VIEWED = 'Top Up Balance Page Viewed',
  SELECT_PAYMENT_METHOD_CHOSEN = 'Select Payment Method Chosen',
  WAITING_FOR_TOP_UP_PAGE_VIEWED = 'Waiting for Top Up Page Viewed',
  VIRTUAL_ACCOUNT_COPIED = 'Virtual Account Copied',
  TOP_UP_BALANCE_PAGE_SUCCESSFULLY = 'Top Up Balance Page Successfully',

  SINGLE_TRANSACTION_APPROVAL_VIEWED = 'Single Transaction Approval Viewed',
  SINGLE_TRANSACTION_APPROVED = 'Single Transaction Approved',
  SINGLE_TRANSACTION_REJECTED = 'Single Transaction Rejected',

  BULK_TRANSACTION_PAGE_VIEWED = 'Bulk Transaction Page Viewed',
  BULK_TRANSACTION_APPROVAL_PAGE_VIEWED = 'Bulk Transaction Approval Page Viewed',
  BULK_TRANSACTION_APPROVED = 'Bulk Transaction Approved',
  BULK_TRANSACTION_REJECTED = 'Bulk Transaction Rejected',

  PENDING_SINGLE_TRANSACTION_PAGE_VIEWED = 'Pending Single Transaction Page Viewed',
  RETRIED_SINGLE_PENDING_TRANSACTION = 'Retried Single Pending Transaction',
  CANCELED_SINGLE_PENDING_TRANSACTION = 'Canceled Single Pending Transaction',

  PENDING_BULK_TRANSACTION_PAGE_VIEWED = 'Pending Bulk Transaction Page Viewed',
  RETRIED_BULK_PENDING_TRANSACTION = 'Retried Bulk Pending Transaction',
  CANCELED_BULK_PENDING_TRANSACTION = 'Canceled Bulk Pending Transaction',

  TOTAL_PAYOUT_VIEWED = 'Total Payout Viewed',
  PAYOUT_SUCCESS_STATUS_VIEWED = 'Payout Success Status Viewed',
  PAYOUT_PENDING_STATUS_VIEWED = 'Payout Pending Status Viewed',
  PAYOUT_FAILED_STATUS_VIEWED = 'Payout Failed Status Viewed',
  PAYOUT_CANCELLED_STATUS_VIEWED = 'Payout Cancelled Status Viewed',
  PAYOUT_APPROVED_STATUS_VIEWED = 'Payout Approved Status Viewed',
  PAYOUT_REJECTED_STATUS_VIEWED = 'Payout Rejected Status Viewed',
  PAYOUT_WAITING_STATUS_VIEWED = 'Payout Waiting Status Viewed',

  PAYOUT_DETAIL_VIEWED_PAGE = 'Payout Detail Viewed Page',
  BATCH_HISTORY_VIEWED_PAGE = 'Batch History Viewed Page',
  BATCH_DETAIL_VIEWED_PAGE = 'Batch Detail Viewed Page',

  PAYMENT_CHARGEBACK_STATUS_VIEWED = 'Payment Chrageback Status Viewed',

  WAITING_FOR_KYC_STATUS_VIEWED = 'Waiting for KYC Status Viewed',

  FAILURE_PAYOUT_STATUS_VIEWED = 'Failure Payout Status Viewed',

  // XB (Cross-border) Payout Status Events
  INTERNATIONAL_PAYOUT_PAGE_VIEWED = 'International Payout Page Viewed',

  LOGIN_PAGE = 'Login Page',

  PLATFORM_ALL_STATUS_VIEWED = 'Platform All Status Viewed',

  // Hompage Tour Event
  HOMEPAGE_TUTORIAL_DIALOG_VIEWED = 'Homepage Tutorial Dialog Viewed',
  HOMEPAGE_TUTORIAL_DIALOG_ACTION = 'Homepage Tutorial Dialog Action',
  HOMEPAGE_TUTORIAL_COMPLETE = 'Homepage Tutorial Complete',
  HOMEPAGE_TUTORIAL_SKIP = 'Homepage Tutorial Skip',
  HOMEPAGE_TUTORIAL_ACTION = 'Homepage Tutorial Action',
  HOMEPAGE_TUTORIAL_VIEWED = 'Homepage Tutorial Viewed',

  // Account & Balance Management Events
  ACCOUNT_BALANCE_MANAGEMENT_PAGE_VIEWED = 'Account & Balance Management Page Viewed',
  ACCOUNT_TYPE_POP_UP_VIEWED = 'Account Type Pop Up Viewed',
  ACCOUNT_TYPE_POP_UP_CHOSEN = 'Account Type Pop Up Chosen',
  ACCOUNT_TYPE_NON_KYC_CHOSEN = 'Account Type Non-KYC Chosen',
  ACCOUNT_TYPE_KYC_CHOSEN = 'Account Type KYC Chosen',
  ADD_NEW_MERCHANT_PAGE_VIEWED = 'Add New Merchant Page Viewed',
  ADD_NEW_MERCHANT_PAGE_CREATED = 'Add New Merchant Page Created',
  MERCHANT_DETAIL_VIEWED_PAGE = 'Merchant Detail Viewed Page',

  // Home Page - Payout Insight & Require Action Events
  PAYOUT_INSIGHT_WAITING_FOR_APPROVAL_VIEWED = 'Payout Insight - Waiting for Approval Viewed',
  REQUIRE_ACTION_PAYOUT_WAITING_FOR_APPROVAL_VIEWED = 'Require Action - Payout Waiting for Approval Viewed',
  REQUIRE_ACTION_PAYOUT_WAITING_FOR_TOP_UP_VIEWED = 'Require Action - Payout Waiting for Top Up Viewed',
  REQUIRE_ACTION_INTL_PAYOUT_INFORMATION_REQUESTED_VIEWED = 'Require Action - International Payout Information Requested Viewed',
  PAYOUT_INSIGHT_DELAYED_VIEWED = 'Payout Insight - Delayed Viewed',
  PAYOUT_INSIGHT_ALL_STATUS_SUCCESS_VIEWED = 'Payout Insight - All Status Success Viewed',
  PAYOUT_INSIGHT_ALL_STATUS_PENDING_VIEWED = 'Payout Insight - All Status Pending Viewed',
}

export enum GTMEventCategory {
  BUTTON = 'Button',
  FORM = 'Form',
  PAGE = 'Page',
  MODAL = 'Modal',
  LINK = 'Link',
}
